interface CircularPercentageProps {
  percentage: number;
  color: string;
  size?: number;
  strokeWidth?: number;
  remainingColor?: string;
}

const CircularPercentage = ({
  percentage,
  color,
  remainingColor = "#E0E0E0",
  size = 50,
  strokeWidth = 5,
}: CircularPercentageProps) => {
  
  // 🔹 ROUND percentage (and keep it safe between 0–100)

  const roundedPercentage = Math.min(100, Math.max(0, Math.round(percentage)));

  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (roundedPercentage / 100) * circumference;

  return (
    <svg width={size} height={size}>
      {/* Remaining / Background circle */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={remainingColor}
        strokeWidth={strokeWidth}
        fill="none"
      />

      {/* Progress circle */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        stroke={color}
        strokeWidth={strokeWidth}
        fill="none"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />

      {/* Center text */}
      <text
        x="50%"
        y="50%"
        dominantBaseline="middle"
        textAnchor="middle"
        fontSize="11"
        fontWeight="600"
        fill="#000"
      >
        {roundedPercentage}%
      </text>
    </svg>
  );
};

export default CircularPercentage;
